const ConfiguratorActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    SHOW_EXTENDED_ACTION: 'SHOW_EXTENDED_ACTION',
    HIDE_ACTION: 'HIDE_ACTION',
    SHOW_FIRST_LAYER: 'SHOW_FIRST_LAYER',
    SHOW_SECOND_LAYER: 'SHOW_SECOND_LAYER',
    SHOW_INFO_LAYER: 'SHOW_INFO_LAYER',
    HIDE_INFO_LAYER: 'HIDE_INFO_LAYER',
    SHOW_INFO_PROVIDE_SIZE: 'SHOW_INFO_PROVIDE_WIDTH',
    SHOW_INFO_PROVIDE_INDEX: 'SHOW_INFO_PROVIDE_INDEX',
    SHOW_INFO_POSTCODE_INVALID: 'SHOW_INFO_POSTCODE_INVALID',
    HIDE_SIZE_INFO: 'HIDE_SIZE_INFO',
    HIDE_INDEX_INFO: 'HIDE_INDEX_INFO',
    HIDE_POSTCODE_INVALID: 'HIDE_POSTCODE_INVALID',
    SET_WIDTH: 'SET_WIDTH',
    SET_HEIGHT: 'SET_HEIGHT',
    SET_DIAMETER: 'SET_DIAMETER',
    SET_SPEED_INDEX: 'SET_SPEED_INDEX',
    SET_LOAD_INDEX: 'SET_LOAD_INDEX',
    SET_POSTCODE: 'SET_POSTCODE',
    SET_CONFIGURATOR_TYPE: 'SET_CONFIGURATOR_TYPE',
    SET_PAGE_ORIGIN_TYPE: 'SET_PAGE_ORIGIN_TYPE',
    SET_VALUES: 'SET_VALUES',
    SET_BACKUP_VALUES: 'SET_BACKUP_VALUES',
    SET_VISIBLE_SECTIONS: 'SET_VISIBLE_SECTIONS',
    SET_OUT_OF_STOCK_CHECK_LOADING: 'SET_OUT_OF_STOCK_CHECK_LOADING',
    SET_OUT_OF_STOCK_CHECK_LOADING_DONE: 'SET_OUT_OF_STOCK_CHECK_LOADING_DONE',
    SET_OUT_OF_STOCK: 'SET_OUT_OF_STOCK',
    SET_IN_STOCK: 'SET_IN_STOCK',
    SET_LOAD_INDEX_OPTIONS: 'SET_LOAD_INDEX_OPTIONS',
    SET_SPEED_INDEX_OPTIONS: 'SET_SPEED_INDEX_OPTIONS',
    SHOW_TYRE_INDEX: 'SHOW_TYRE_INDEX',
    HIDE_TYRE_INDEX: 'HIDE_TYRE_INDEX',
    SHOW_TYRE_INDEX_LINK: 'SHOW_TYRE_INDEX_LINK',
    HIDE_TYRE_INDEX_LINK: 'HIDE_TYRE_INDEX_LINK',
    SET_POSTCODE_SUGGESTION: 'SET_POSTCODE_SUGGESTION'
};

export { ConfiguratorActions };
